import React, { useState } from 'react';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../constant';
import dayjs from 'dayjs';
import moment from 'moment';
import EventUpdateForm from '../updateForm'
import Paginations from '../../common/paginations';
import { hasPermission } from '../../../utils/hasPermission';

const formatHullNumber = (hullNumber) => {
    const normalizedHull = String(hullNumber || '').trim().replace(/^HN[\s-]*/i, '');
    return normalizedHull ? `HN ${normalizedHull}` : 'HN';
};

const List = ({ history, record, onUpdateEvent, onDeleteEvent, deletingEventId, setCurrentPage }) => {
    const { data, pagination } = record;
    const sortedData = Array.isArray(data)
        ? [...data].sort((a, b) => dayjs(a.END_DATE).valueOf() - dayjs(b.END_DATE).valueOf())
        : [];
    const { page, limit, total } = pagination || {};
    const [selectedEvent, setSelectedEvent] = useState(null);

    const hasEditPermission = hasPermission(50);
    const hasDeletePermission = hasPermission(constant.actionPermission.scheduleDeleteEvent);
    return (
        <div className="row" >
            <div className="col-lg-12">
                {/* <div className="card"> */}
                <div>
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Upcoming Events</h4>
                        <div>
                            <button
                                type="button"
                                className="btn btn-sm btn-primary me-2"
                                style={{ backgroundImage: "linear-gradient(90deg, #6895b4, #265578)" }}
                                data-bs-toggle="modal"
                                data-bs-target="#schedule-export-columns-modal"
                            >
                                <i className="mdi mdi-file-excel-outline label-icon" /> Export Records
                            </button>
                            <button
                                className="btn btn-sm btn-primary"
                                style={{ backgroundImage: "linear-gradient(90deg, #6895b4, #265578)" }}
                                onClick={() => { history.push(constant.Authedcomponent.addEventSchdule.url) }}
                            >
                                <i className="bx bx-plus" /> New Schedule
                            </button>
                        </div>

                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-upcoming-events align-middle table-nowrap table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" style={{ width: 70 }}>
                                            <i className="bx bx-time bx-tada" style={{ fontSize: 18 }} />
                                        </th>
                                        <th scope="col">Events</th>
                                        <th scope="col">Hull</th>

                                        <th scope="col">Time Left</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {sortedData.length > 0 ? sortedData.map(event => {

                                        const today = dayjs();
                                        const end = dayjs(event.END_DATE);
                                        const diff = end.diff(today, 'day');


                                        const getBadge = () => {
                                            if (diff > 0) return <span className="badge bg-primary" style={{
                                                padding: '3px 10px',
                                                borderRadius: '12px',
                                                fontSize: '11px',

                                            }}>{diff} day{diff > 1 ? 's' : ''} left</span>;
                                            if (diff === 0) return <span className="badge bg-warning text-dark" style={{
                                                padding: '3px 10px',
                                                borderRadius: '12px',
                                                fontSize: '11px',

                                            }}>Ends today</span>;
                                            return <span className="badge bg-success" style={{
                                                padding: '3px 10px',
                                                borderRadius: '12px',
                                                fontSize: '11px',

                                            }}>{Math.abs(diff)} day{Math.abs(diff) > 1 ? 's' : ''} ago</span>;
                                        };
                                        return (
                                            <React.Fragment>

                                                <tr>
                                                    <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                                        {moment(event.END_DATE).format('DD MMM YYYY').toUpperCase()}
                                                    </td>

                                                    <td>
                                                        <div style={{ color: event.COLOR_CODE || 'black', fontSize: '13px', marginBottom: '0.25rem' }}>
                                                            <span style={{ color: "#8c8c8c", textTransform: 'uppercase' }}>{event.CATEGORY_NAME}</span>
                                                            &nbsp;<i className='mdi mdi-arrow-right text-primary' />&nbsp;
                                                            {event.EVENT_TYPE}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style={{ color: event.COLOR_CODE || 'black', fontSize: '13px', marginBottom: '0.25rem' }}>

                                                            <span style={{ color: "#ab5858" }}>
                                                                {formatHullNumber(event.HULL_NUMBER)} - {event.SHIP_NAME}
                                                            </span>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            {hasEditPermission && <button type="button" title="Update Event" className="btn btn-link p-0 border-0 font-size-20 text-primary"
                                                                style={{ lineHeight: 1 }}
                                                                data-bs-toggle="modal"
                                                                data-bs-target={`#eventUpdateModal`}
                                                                onClick={() => setSelectedEvent(event)}
                                                            >
                                                                <i className="bx bx-edit" style={{ fontSize: '18px' }} />
                                                            </button>}

                                                            {hasDeletePermission && <button
                                                                type="button"
                                                                title="Delete Event"
                                                                className="btn btn-link p-0 border-0 font-size-20 text-danger"
                                                                style={{ lineHeight: 1 }}
                                                                disabled={String(deletingEventId) === String(event.ID)}
                                                                onClick={() => onDeleteEvent(event)}
                                                            >
                                                                <i className={String(deletingEventId) === String(event.ID) ? 'bx bx-loader bx-spin' : 'bx bx-trash'} style={{ fontSize: '18px' }} />
                                                            </button>}


                                                            {getBadge()}

                                                        </div>
                                                    </td>


                                                </tr>
                                                {/* Modal */}
                                                {/* <div
                                                    className="modal fade"
                                                    id={`eventUpdateModal-${event.ID}`}
                                                    data-bs-backdrop="static"
                                                    data-bs-keyboard="false"
                                                    tabIndex={-1}
                                                    role="dialog"
                                                    aria-labelledby="eventUpdateModalLabel"
                                                    aria-hidden="true"
                                                >
                                                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5 className="modal-title" id="eventUpdateModalLabel">
                                                                    Event Update
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                />
                                                            </div>
                                                            <div className="modal-body">
                                                                <  EventUpdateForm
                                                                    data={event}
                                                                    onSubmit={(model) => onUpdateEvent(model)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </React.Fragment>
                                        )
                                    }) : (
                                        <tr>
                                            <td colSpan="4" className="text-center text-muted py-4">No upcoming event found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* ✅ Single Modal outside loop */}
                        <div
                            className="modal fade"
                            id="eventUpdateModal"
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabIndex={-1}
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Event Update</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                    </div>
                                    <div className="modal-body">
                                        {selectedEvent ? (
                                            <EventUpdateForm data={selectedEvent} onSubmit={(model) => onUpdateEvent(model)} />
                                        ) : (
                                            <p className="text-muted">Loading...</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Paginations
                            range={5}
                            limit={limit}
                            totalCount={total}
                            currentPage={page}
                            onPageChange={setCurrentPage}
                        />
                    </div>
                </div>
            </div>

        </div>


    );
};

export default withRouter(List);
